export default (state, { payload: { itemId } }) => ({
  ...state,
  lastItemWithSizeSelectErrorId: itemId
});
